var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"justify":"center"}},[_c('a',{attrs:{"href":_vm.link_url}},[_c('v-img',{attrs:{"href":_vm.link_url,"src":_vm.url,"max-height":_vm.height,"contain":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }